import { reactive, computed } from '@vue/composition-api'
import * as common from '@/util/common'

export const SystemNotice = (context) => {
  const store = context.root.$store

  const notice = reactive({
    title: computed(() => {
      let title = store.state.common.notice.title.replace('\\n', '\n')
      title = common.escapeHTML(title)
      return title.replace(/\r?\n/g, '<br>')
    }),
    text: computed(() => {
      let text = store.state.common.notice.text.replace('\\n', '\n')
      text = common.escapeHTML(text)
      return text.replace(/\r?\n/g, '<br>')
    }),

    isButton1Shown: computed(() => {
      return store.state.common.notice.button1.show
    }),
    button1Text: computed(() => {
      return store.state.common.notice.button1.text
    }),
    button1Action: computed(() => {
      return store.state.common.notice.button1.action
    }),
    isButton2Shown: computed(() => {
      return store.state.common.notice.button2.show
    }),
    button2Text: computed(() => {
      return store.state.common.notice.button2.text
    }),
    button2Action: computed(() => {
      return store.state.common.notice.button2.action
    }),
    isButtonCloseShown: computed(() => {
      return store.state.common.notice.buttonClose.show
    }),
    buttonCloseAction: computed(() => {
      return store.state.common.notice.buttonClose.action
    })
  })

  const click = reactive({
    submit1: () => {
      if (notice.button1Action) {
        notice.button1Action()
          .then(() => {
            finalProcess()
          })
      } else {
        finalProcess()
      }
    },
    submit2: () => {
      if (notice.button2Action) {
        notice.button2Action()
          .then(() => {
            finalProcess()
          })
      } else {
        finalProcess()
      }
    }
  })

  /**
   *  「×」ボタン押下時の処理
   */
  const close = () => {
    if (notice.buttonCloseAction) {
      notice.buttonCloseAction()
        .then(() => {
          finalProcess()
        })
    } else {
      finalProcess()
    }
  }

  /**
   *  submitボタンと「×」ボタンの最終処理
   */
  const finalProcess = () => {
    context.emit('closeSystemError')
    store.dispatch('common/hideNotice')
  }

  return {
    notice,
    close,
    click
  }
}
